// src/game/crazy/mysteryOutcomes.js
const outcomes = [
  {
    type: "delight",
    action: "gemRain",
    message: "💎 Gem Shower! Gems are raining down!",
    weight: 2.5,
    repeatable: true,
  },
  {
    type: "delight",
    action: "mysteryCompanion",
    message: "🧚 A glowing spirit follows you… gems are drawn to your presence!",
    weight: 2.5,
    repeatable: true,
  },
  {
    type: "trap",
    action: "demonCurse",
    message: "👹 The Demon devoured 5 of your gems and vanished!",
    weight: 1.5,
    repeatable: false,
  },
  {
    type: "trap",
    action: "controlsInverted",
    message: "🔁 Controls Reversed for 15s! 🌀 Mirror World! Left is right, up is down!",
    weight: 1.5,
    repeatable: false,
  }
];

// 🧠 Track used single-use outcomes
const usedOncePerGame = new Set();

export function resetMysteryTracker() {
  usedOncePerGame.clear();
}

export function getRandomOutcome() {
  const eligible = outcomes.filter((o) => o.repeatable || !usedOncePerGame.has(o.action));
  const totalWeight = eligible.reduce((sum, o) => sum + o.weight, 0);
  let rand = Math.random() * totalWeight;

  for (let o of eligible) {
    rand -= o.weight;
    if (rand <= 0) {
      if (!o.repeatable) usedOncePerGame.add(o.action);
      return o;
    }
  }

  // Fallback
  return eligible[0];
}
